// Campaigns (Craig, 30 Oct 2026; docs/specs/CAMPAIGN_LED_2026_10.md): everything can be done by hand anywhere in Ogma;
// a campaign is what makes it run by itself, so Campaigns is the set-up hub. The list (with Get started until the first
// email has gone), the drafts to approve across every campaign, the firms lined up, the set-ups campaigns share (the
// routes after a reply) and the defaults a new campaign copies. Find's search moved to Contacts › Find.
// Screens are loaded with screen() (see ./screen.ts), never imported directly.
// Campaigns (Craig, 30 Oct 2026; docs/specs/CAMPAIGN_LED_2026_10.md): everything can be done by hand anywhere in Ogma;
// a campaign is what makes it run by itself, so Campaigns is the set-up hub. Since 31 Oct 2026
// (docs/specs/CAMPAIGN_PAGES_2026_10.md): the campaigns as cards and one page per campaign; To approve, a card per
// campaign with its messages to send yourself; Outreach, what went out and what is queued, with the week's plan;
// Lined up, one campaign at a time; and Defaults, what a new campaign starts with. Each campaign sets its own steps
// after a reply, so the shared Routes page moved to Settings › Your business › Reply paths (advanced).
// Screens are loaded with screen() (see ./screen.ts), never imported directly.
import type { SteppedModule } from "./types";
import { screen } from "./screen";

const CampaignsHome = screen(() => import("../screens/campaigns/CampaignsHome"), "CampaignsHome");
const LongListPage = screen(() => import("../screens/find/LongList"), "LongListPage");
const DraftsPage = screen(() => import("../screens/find/Drafts"), "DraftsPage");
const OutreachPage = screen(() => import("../screens/find/Outreach"), "OutreachPage");
const connectPages = () => import("../screens/pipeline/ConnectPages");
const SpeedToLeadRules = screen(connectPages, "SpeedToLeadRules");
const SaveOfferRules = screen(connectPages, "SaveOfferRules");
const SendingStylePage = screen(() => import("../screens/find/SendingStyle"), "SendingStylePage");
const ShareDocumentsPage = screen(() => import("../screens/pipeline/ShareDocuments"), "ShareDocumentsPage");
const WhatsWorkingPage = screen(() => import("../screens/campaigns/WhatsWorkingPage"), "WhatsWorkingPage");

export const campaigns: SteppedModule = {
  key: "campaigns",
  label: "Campaigns",
  layout: "steps",
  tabs: [
    {
      key: "list",
      label: "Campaigns",
      pages: [
        { slug: "", label: "Campaigns", step: "2.30", render: () => <CampaignsHome /> },
        // The learning base (31 Oct 2026): what wins replies across every campaign, and the lessons Ogma writes with
        { slug: "working", label: "What's working", step: "10.8", render: () => <WhatsWorkingPage /> },
      ],
    },
    { key: "to-approve", label: "To approve", pages: [{ slug: "", label: "To approve", step: "4.10", render: () => <DraftsPage /> }] },
    { key: "outreach", label: "Outreach", pages: [{ slug: "", label: "Outreach", step: "4.3", render: () => <OutreachPage /> }] },
    { key: "lined-up", label: "Lined up", pages: [{ slug: "", label: "Lined up", step: "2.1", render: () => <LongListPage /> }] },
    {
      key: "defaults",
      label: "Defaults",
      pages: [
        { slug: "", label: "Defaults", step: "4.2", render: () => <SendingStylePage /> },
        { slug: "speed", label: "Speed to lead", step: "1.61", advanced: true, render: () => <SpeedToLeadRules /> },
        { slug: "save-offer", label: "Save offer", step: "9.11", advanced: true, render: () => <SaveOfferRules /> },
        { slug: "documents", label: "Documents", step: "9.1", advanced: true, render: () => <ShareDocumentsPage /> },
      ],
    },
  ],
  taskHomes: {
    approve_outbox_batch: ["/campaigns/to-approve"],
    // 4.23 messages for firms held for manual outreach only, which the owner sends from their own accounts
    send_by_hand: ["/campaigns/to-approve"],
    linkedin_connect: ["/campaigns/to-approve"],
    same_firm: ["/campaigns/to-approve"],
    // K-03: a colleague at a firm already in touch waits for a yes or no, beside the drafts
    in_touch_check: ["/campaigns/to-approve"],
    // Upgrades Oct 2026: 2.41 a signal play, 4.26 a doubtful letter address
    signal_play: ["/campaigns/to-approve"],
    letter_address_doubtful: ["/campaigns/to-approve"],
    // L-05: a target or offer change on a running campaign waits for approval on the campaign (2.30)
    approve_campaign_change: ["/campaigns/list"],
    // The learning base: the weekly digest of new lessons, with a veto for each
    learning_digest: ["/campaigns/list/working"],
  },
};
